class Search {
    private search: string;
    private timestamp: number;
    private isBeingLoaded: boolean;

    public constructor(search: string) {
        this.search = search;
        this.timestamp = new Date().getTime();
        this.isBeingLoaded = false;
    }

    public getPhrase() : string {
        return this.search;
    }

    public getTimestamp() : number {
        return this.timestamp;
    }

    public isLoading() : boolean {
        return this.isBeingLoaded;
    }

    public setIsLoading(is : boolean) : void {
        this.isBeingLoaded = is;
    }
};

export default Search;


// WEBPACK FOOTER //
// ./src/App/Blocks/Search.ts